import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CreatableSelect from 'react-select/creatable';
import { ToastContainer, toast } from 'react-toastify';

import config from '../../config/config';
import placeholder from '../../assets/images/1080.png';
import constant from '../../utils/Constant';
import Loader from '../partials/Loader';

const {
    FETCH_SEO_END_POINT,
    UPDATE_SEO_END_POINT,
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    LOGOUT,
    STATUS_200,
    STATUS_401,
    S3_BASE_URL,
} = constant;

const AllSEO = () => {
    const navigate = useNavigate();

    const [profileImage, setProfileImage] = useState(placeholder);
    const [selectedKeywords, setSelectedKeywords] = useState([]);
    const [keywordOption, setKeywordOption] = useState([]);
    const [formData, setFormData] = useState({})
    const [loading, setLoading] = useState(falseValue);
    const [disable, setDisable] = useState(falseValue);

    // * handle change keywords
    const handleChange = (newValue) => {
        setSelectedKeywords(newValue);
    };

    // * handle keyword create
    const handleCreate = (inputValue) => {
        const newOption = { value: inputValue, label: inputValue };
        setKeywordOption(prev => [...prev, newOption]);
        setSelectedKeywords(prev => [...prev, newOption]);
    };

    // * handle profile image 
    const handleProfileImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileImage(URL.createObjectURL(file));
        }
    };

    // * get token from local storage
    const token = localStorage.getItem('vendor_super_token');

    // * execute all seo request api
    const executeFetchSEOApi = useCallback(async () => {
        try {
            const apiUrl = config.appBaseUrl + FETCH_SEO_END_POINT;

            // * execute get request
            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // * api response
            const result = response.data;

            // * if response is success
            if (result.code === STATUS_200 && result.status) {
                setFormData({
                    title: result.data?.title,
                    description: result.data?.description
                })
                setProfileImage(result.data?.image ? `${S3_BASE_URL}${result.data?.image}` : placeholder);

                const keywordsArray = result.data.keywords.map((keyword) => ({
                    label: keyword,
                    value: keyword,
                }));
                setSelectedKeywords(keywordsArray);
            }
        } catch (error) {
            toast.error(error.response?.data?.message);

            // * if token is expired
            if (error.response?.data?.code === STATUS_401) {
                navigate(LOGOUT);
            }
        }
    }, [navigate, token]);

    // * execute all seo request api
    useEffect(() => {
        executeFetchSEOApi();
    }, [executeFetchSEOApi, token]);

    // * execute update seo
    const executeUpdateSEOApi = async () => {

        setLoading(trueValue);
        setDisable(trueValue);

        const data = new FormData();

        const img = document.getElementById('upload-photo');
        data.append('image', img.files[0] || null);
        data.append('title', formData.title);
        data.append('description', formData.description);
        const keywordValues = selectedKeywords.map(item => item.value);
        data.append('keywords', JSON.stringify(keywordValues));


        try {
            const apiUrl = config.appBaseUrl + UPDATE_SEO_END_POINT;

            //* post request
            const response = await axios.post(apiUrl, data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            //* response success
            const result = response.data;
            if (result.code === STATUS_200 && result.status) {
                toast.success(result.message);
                executeFetchSEOApi();
            } else {
                toast.error(result.message);
            }
        }
        catch (error) {
            toast.error(error.response?.data?.message);

            // * if user is unauthorized
            if (error.response?.data?.code === STATUS_401) {
                navigate(LOGOUT);
            }
        } finally {
            setDisable(falseValue);
            setLoading(falseValue);
        }
    };

    return (
        <>
            <ToastContainer autoClose={700} position='top-center' />

            <div className='page-content'>
                <div className='container-fluid'>
                    {/* //* start page title */}
                    <div className='row'>
                        <div className='col-12'>
                            <div className='page-title-box d-flex  align-items-start align-items-sm-center justify-content-between gap-2'>
                                <h4 className='mb-2 mb-sm-0'>SEO</h4>
                                <div className='page-title-right'>
                                    <ol className='breadcrumb m-0'>
                                        <li className='breadcrumb-item'>
                                            <Link to='/dashboard'>Dashboard</Link>
                                        </li>
                                        <li className='breadcrumb-item active'>SEO</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='card'>
                                <div className='card-body'>

                                    <div className='row w-100 d-flex align-items-start justify-content-center'>

                                        {/* //* Left side - Profile Image */}
                                        <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3 mb-md-0 d-flex justify-content-center'>
                                            <div
                                                className='ps-2'
                                                style={{
                                                    position: 'relative',
                                                    width: '100%',
                                                    aspectRatio: '4 / 3',
                                                    marginTop: '6px',
                                                }}
                                            >
                                                <img
                                                    src={profileImage}
                                                    alt='Profile'
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '8px',
                                                    }}
                                                />
                                                <label
                                                    htmlFor='upload-photo'
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-8px',
                                                        right: '-13px',
                                                        background: '#fff',
                                                        borderRadius: '50%',
                                                        padding: '3px 6px',
                                                        fontSize: '13px',
                                                        cursor: 'pointer',
                                                        boxShadow: '0 0 5px rgba(0,0,0,0.2)',
                                                    }}
                                                >
                                                    🖉
                                                </label>
                                                <input
                                                    type='file'
                                                    id='upload-photo'
                                                    style={{ display: 'none' }}
                                                    accept='image/*'
                                                    onChange={handleProfileImage}
                                                />
                                            </div>
                                        </div>


                                        {/* //* Right side - Inputs */}
                                        <div className='col-12 col-md-12 col-lg-6  col-xl-8 col-xxl-9 '>
                                            <div className='row'>

                                                {/* //* title */}
                                                <div className='col-12 col-md-12 mb-2 pe-0'>
                                                    <label htmlFor='name' className='form-label'>Title</label>
                                                    <input
                                                        type='text'
                                                        className='form-control m-0'
                                                        id='name'
                                                        placeholder='Enter name'
                                                        value={formData.title}
                                                        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                                    />
                                                </div>

                                                {/* //* description */}
                                                <div className='col-12 pe-0  mb-2'>
                                                    <label htmlFor='description' className='form-label'>Description</label>
                                                    <textarea
                                                        type='number'
                                                        id='description'
                                                        name='description'
                                                        className='form-control mb-0'
                                                        placeholder='Enter description'
                                                        rows={4}
                                                        autoComplete='off'
                                                        value={formData.description}
                                                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                                    />
                                                </div>

                                                {/* //* keywords */}
                                                <div className=' col-12 col-md-12 pe-0'>
                                                    <label htmlFor='keywords' className='form-label'>Keywords</label>
                                                    <CreatableSelect
                                                        isMulti
                                                        id='keywords'
                                                        name='service'
                                                        options={keywordOption}
                                                        value={selectedKeywords}
                                                        className='basic-multi-select'
                                                        classNamePrefix='selectd'
                                                        placeholder='Select or type and press enter...'
                                                        onChange={handleChange}
                                                        onCreateOption={handleCreate}
                                                    />
                                                </div>

                                            </div>
                                        </div>

                                        {/* //* buttons */}
                                        <div className='d-flex align-items-center justify-content-end mt-4 pe-0 pb-2'>
                                            <button
                                                className='btn btn-primary'
                                                onClick={executeUpdateSEOApi}
                                                disabled={disable}
                                            >
                                                {!loading ? 'Update' : <Loader />}
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AllSEO;